import React from 'react';
import { Help, InsertComment } from '@mui/icons-material';
import styled from 'styled-components';
import { COLOR_ACCENT, COLOR_BACKGROUND_BRIGHT, COLOR_DESCRIPTION, COLOR_PRIMARY, COLOR_SECONDARY, DEVICES } from '../../const';

const Container = styled.div`
  background-color: #fff;
`;

const Inner = styled.div`
  margin: auto;

  @media ${DEVICES.mobile} {
    display: block;
    padding: 72px 0;
  }

  @media ${DEVICES.tablet} {
    display: flex;
    padding: 160px 0;
  }

  @media ${DEVICES.large} {
    display: flex;
    max-width: 1200px;
  }
`;

const Right = styled.div`
  padding: 0 2rem;
  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const RightHeading = styled.div`
  font-weight: 700;
  color: ${COLOR_ACCENT};

  @media ${DEVICES.mobile} {
    margin-top: 80px;
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    margin-top: 0;
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    margin-top: 0;
  }
`;

const RightTitle = styled.div`
  font-weight: 700;
  line-height: 1.3;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
    margin-top: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
    margin-top: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const RightDescription = styled.div`
  margin-top: 2.5rem;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightQuestion = styled.div`
  margin-top: 2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightQuestionMark = styled.div`
  min-width: 50px;
  line-height: 1;
`;

const RightQuestionText = styled.div`
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.25rem;
  }
`;

const RightAnswer = styled.div`
  margin-top: 2rem;
  display: flex;
  color: ${COLOR_DESCRIPTION};
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 0.8rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const RightAnswerMark = styled.div`
  min-width: 50px;
  line-height: 1;
  color: #000;
`;

const RightAnswerText = styled.div`
`;

const RightHighlight = styled.div`
  margin-top: 40px;
  padding: 1.5rem 1rem;
  border-radius: 1rem;
  background-color: ${COLOR_BACKGROUND_BRIGHT};
  box-shadow: 1px 25px 57px -25px rgb(0 0 0 / 20%);
`;

const RightHighlightBold = styled.div`
  font-weight: 600;
  color: ${COLOR_ACCENT};
  display: flex;
  align-items: center;
`;

const Left = styled.div`
  padding: 1rem 2rem;
  @media ${DEVICES.mobile} {
    justify-content: center;
  }

  @media ${DEVICES.tablet} {
    width: 50%;
  }

  @media ${DEVICES.large} {
    width: 50%;
  }
`;

const LeftImg = styled.img`
  width: 100%;
  border-radius: 20px;
`;

export default function StrengthAbilityBanner() {
  return (
    <Container>
      <Inner>
        <Left>
          <LeftImg src="https://kangaroo-edu-main.s3.ap-northeast-2.amazonaws.com/landing-page/home/strength_ability.jpg" />
        </Left>
        <Right>
          <RightHeading>
            OUR FEATURES. 01
          </RightHeading>
          <RightTitle>
            캥거루짐만의 9가지 기능성 운동
          </RightTitle>
          <RightDescription>
            운동도 공부와 마찬가지로 <br />
            가장 중요한 것은 기본기입니다
          </RightDescription>
          <RightDescription>
            특히나 한창 성장 중인 아이들에게는 <br />
            신체 기능에 대한 이해가 수반된 운동은 <br />
            필수적입니다
          </RightDescription>
          <RightHighlight>
            <RightHighlightBold>아이들이 운동에 재미를 느끼는 순간은</RightHighlightBold>
            스스로 몸을 컨트롤 할 수 있다는 자신감을 가질 때 입니다
          </RightHighlight>
          <RightQuestion>
            <RightQuestionMark>
              <Help />
            </RightQuestionMark>
            <RightQuestionText>
              어린 아이들이 재미있어 할까요?
            </RightQuestionText>
          </RightQuestion>
          <RightAnswer>
            <RightAnswerMark>
              <InsertComment />
            </RightAnswerMark>
            <RightAnswerText>
              캥거루짐에서 진행하는 9가지의 기능성 운동들은 모두 도전적이며 <br />
              창의적입니다. 또는 목표 지향적인 프로그램으로 구성되어 있어 <br />
              어린 아이들이 즐겁게 수행할 수 있답니다
            </RightAnswerText>
          </RightAnswer>
        </Right>
      </Inner>
    </Container>
  )
}
